(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root){
    var els = (root||document).querySelectorAll('.hs-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e,i){ e.style.transitionDelay = (e.dataset.delay||0)+'ms'; io.observe(e); });
  }

  function initVideos(root){
    var vids = (root||document).querySelectorAll('video[data-hs-autoplay]');
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var v = en.target;
        if(en.isIntersecting){ var p = v.play(); if(p && p.catch) p.catch(function(){}); } else { v.pause(); }
      });
    },{threshold:0.35});
    vids.forEach(function(v){ v.muted = true; v.setAttribute('playsinline',''); io.observe(v); });
  }

  function initSound(root){
    (root||document).querySelectorAll('[data-hs-sound]').forEach(function(btn){
      if(btn.dataset.bound) return; btn.dataset.bound = '1';
      btn.addEventListener('click',function(){
        var v = btn.closest('.hs-reel').querySelector('video');
        if(!v) return;
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.textContent = v.muted ? 'Son off' : 'Son on';
        if(!v.muted){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      });
    });
  }

  function initQuiz(root){
    (root||document).querySelectorAll('[data-hs-quiz]').forEach(function(q){
      if(q.dataset.bound) return; q.dataset.bound = '1';
      var btns = q.querySelectorAll('[data-hs-answer]');
      var results = q.querySelectorAll('[data-hs-result]');
      btns.forEach(function(b){
        b.addEventListener('click',function(){
          btns.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
          b.setAttribute('aria-pressed','true');
          results.forEach(function(r){ r.hidden = r.dataset.hsResult !== b.dataset.hsAnswer; });
          var shown = q.querySelector('[data-hs-result="'+b.dataset.hsAnswer+'"]');
          if(shown){ shown.classList.remove('is-in'); requestAnimationFrame(function(){ shown.classList.add('is-in'); }); if(window.innerWidth<750) shown.scrollIntoView({behavior: reduce?'auto':'smooth', block:'nearest'}); }
        });
      });
    });
  }

  function initGallery(root){
    (root||document).querySelectorAll('[data-hs-gallery]').forEach(function(g){
      if(g.dataset.bound) return; g.dataset.bound = '1';
      var track = g.querySelector('[data-hs-track]');
      var dots = g.querySelectorAll('[data-hs-dot]');
      if(!track || !dots.length) return;
      dots.forEach(function(d,i){ d.addEventListener('click',function(){ track.scrollTo({left: track.clientWidth*i, behavior: reduce?'auto':'smooth'}); }); });
      track.addEventListener('scroll',function(){
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth,1));
        dots.forEach(function(d,j){ d.setAttribute('aria-current', j===i ? 'true':'false'); });
      },{passive:true});
    });
  }

  function initQty(root){
    (root||document).querySelectorAll('[data-hs-qty]').forEach(function(w){
      if(w.dataset.bound) return; w.dataset.bound='1';
      var input = w.querySelector('input');
      w.querySelectorAll('[data-step]').forEach(function(b){
        b.addEventListener('click',function(){
          var v = parseInt(input.value||'1',10) + parseInt(b.dataset.step,10);
          input.value = Math.max(1, Math.min(99, v));
        });
      });
    });
  }

  function initSticky(root){
    var bar = (root||document).querySelector('[data-hs-sticky]');
    var target = (root||document).querySelector('[data-hs-sticky-target]');
    if(!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', String(!past));
      });
    },{threshold:0});
    io.observe(target);
  }

  function initAll(root){ initReveal(root); initVideos(root); initSound(root); initQuiz(root); initGallery(root); initQty(root); initSticky(root); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded',function(){ initAll(document); }); } else { initAll(document); }
  document.addEventListener('shopify:section:load',function(e){ initAll(e.target); });
})();
